import { BdaService } from "./BdaService";
import { ExecutionStatus } from "./generics";

export enum WorkflowMode {
  BATCH = 'BATCH',
  STREAM = 'STREAM',
}

interface ServiceStatus {
  dateOfLastStatus: string;
  serviceId: number;
  serviceRef: string;
  serviceStatus: string;
  startDate: string;
}

export interface Execution {
  assetFiles: [];
  currentStatus: ExecutionStatus;
  dateOfLastStatus: string;
  id: number;
  k8sRunId: string;
  runType: string; // TODO check values for this (enum?)
  scheduleId: number;
  environmentVariables?: Record<string, any>;
  servicesStatus: ServiceStatus[];
  startDate: string;
  namespace?: string;
}

export class Schedule {
  cronExpression: string;
  id?: number;
  name: string;
  suspend: boolean;
  timezone: any;

  constructor() {
    this.name = "";
    this.cronExpression = "";
    this.suspend = false;
  }
}

export interface WorkflowStatusModel {
  bdaId: number;
  currentUpdate: string;
  endTime: string;
  executorId: number;
  executorName: string;
  executorOrgId: number;
  executorOrgName: string;
  id: number;
  initTime: string;
  k8sRunId: number;
  message: string;
  organizationId: number;
  ownerId: number;
  scheduleId: number;
  serviceId: number;
  serviceName: string;
  status: ExecutionStatus;
  workflowId: number;
  workflowName: string;
}

export interface Workflow {
  executionId?: number;
  id?: number;
  mode: WorkflowMode;
  name?: string;
  procedure: any[];
  runs?: Execution[];
  schedules?: Schedule[];
  services: BdaService[];
  status?: ExecutionStatus;
  statusModel?: WorkflowStatusModel;
  targetPlatform?: string;
  translation: any;
}